import * as classnames from 'classnames';
import * as React from 'react';

import { FormattedMessage } from 'react-intl';
import { change, WrappedFieldProps } from 'redux-form';

import './InputTextarea.scss';

export interface InputTextareaProps {
  className?: string;
  disabled?: boolean;
  label: string;
  rows?: number;
}

export class InputTextarea extends React.Component<InputTextareaProps & WrappedFieldProps, {}> {
  private input: HTMLTextAreaElement;

  constructor(props: InputTextareaProps & WrappedFieldProps) {
    super(props);

    this.resetInputValue = this.resetInputValue.bind(this);
    this.setReference = this.setReference.bind(this);
  }

  focus() {
    return this.input.focus();
  }

  render() {
    const { className, disabled, input, label, meta, rows } = this.props;
    const classNameElementError = meta.touched && meta.error && 'input-textarea__element--is-error';
    const classNameFootnoteError = meta.touched && meta.error && 'input-textarea__footnote--is-error';
    const classNameStatus = input.value && 'input-textarea__element--is-filled';
    const defaultRows = 5;
    return (
      <div className={classnames('input-textarea__container', className)}>
        <textarea
          autoComplete="off"
          className={classnames('input-textarea__element', classNameElementError, classNameStatus)}
          disabled={disabled}
          id={this.inputId}
          ref={this.setReference}
          rows={rows || defaultRows}
          spellCheck={false}
          {...input}
        />

        <label className="input-textarea__label" htmlFor={this.inputId}>{label}</label>

        <p className={classnames('input-textarea__footnote', classNameFootnoteError)}>
          {meta.touched && meta.error && <span><FormattedMessage id={meta.error}/></span>}
        </p>
      </div>
    );
  }

  get inputId() {
    return 'input-textarea__id-' + this.props.input.name;
  }

  private resetInputValue() {
    const { input, meta } = this.props;
    meta.dispatch(change(meta.form, input.name, ''));
  }

  private setReference(htmlTextAreaElement: HTMLTextAreaElement) {
    this.input = htmlTextAreaElement;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Input/InputTextarea/InputTextarea.tsx